<template>
	<div class="avatar-picture-virtual-watch">
		<div v-if="picture" :style="style" class="avatar-picture"></div>
		<shape src="/static/svg/watch/watch.svg" class="avatar-mask" :class="{ visible: picture }"/>
	</div>
</template>

<script>
import generateBase64Picture from '@/utils/generateBase64Picture'
export default {
	props: [
		'user_uid',
		'watch_id',
		'watch'
	],
	data () {
		return {
			name: 'avatar picture virtual watch',
			pictureData: null
		}
	},
	computed: {
		pictureStore () {
			return this.$store.getters.getWatchPicture(this.watch_id)
		},
		picture () {
			return this.pictureStore || this.pictureData
		},
		style () {
			return `background-image:url('${this.picture}')`
		}
	},
	methods: {
		getPicture () {
			const getPictureData = function (context, user_uid, file_uid) {
				return context.$api.files.get(context, user_uid, null, file_uid)
					.then(response => {
						context.$log.info(context.name, 'files.get OK', response)()
						return response.body
					}).catch(error => {
						context.$log.error(context.name, 'files.get ERROR', error)()
					})
			}
			const getPictureMetadata = function (context, user_uid, file_uid) {
				return context.$api.files.getMetadata(context, user_uid, null, file_uid)
					.then(response => {
						context.$log.info(context.name, 'files.getMetadata OK', response)()
						return response.body
					}).catch(error => {
						context.$log.error(context.name, 'files.getMetadata ERROR', error)()
					})
			}

			const user_uid = this.user_uid
			const file_uid = this.watch.data.picture_uid
			Promise.all([ getPictureData(this, user_uid, file_uid), getPictureMetadata(this, user_uid, file_uid) ])
				.then(([ data, metadata ]) => {
					this.$log.info(this.name, 'getPicture() OK', [ data, metadata ])()
					this.pictureData = generateBase64Picture(data, metadata.extension)
				}).catch(error => {
					this.$log.error(this.name, 'getPicture() ERROR', error)()
				})
		}
	},
	created () {
		if (!this.pictureStore && (this.watch && this.watch.data.picture_uid))
			this.getPicture()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/avatars/AvatarPictureVirtualWatch.vue